import { render, staticRenderFns } from "./GrupoContratoForm.vue?vue&type=template&id=0890dead"
import script from "./GrupoContratoForm.vue?vue&type=script&lang=js"
export * from "./GrupoContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports